import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import QuizMCQsLayer from "../components/QuizMCQsLayer";

const QuizMCQsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Quiz MCQs" />

        {/* QuizMCQsLayer */}
        <QuizMCQsLayer />
      </MasterLayout>
    </>
  );
};

export default QuizMCQsPage;
